import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";
import {getParamsFromString} from "../../../Utils";
import {useMediaQuery} from "@material-ui/core";
// Core modules imports are same as usual
import {Navigation, Pagination, Autoplay} from 'swiper';
// Direct React component imports
import {Swiper, SwiperSlide} from 'swiper/react';
import RenderComponents from "../RenderComponents";
import {uid} from "react-uid";
import 'swiper/css/bundle';
import './swiper-custom.css'
const modules = {
    autoplay: [Autoplay],
    nonAutoplay: [Pagination]
}
const SwiperComponent = props => {
    const {component: {properties, styles: sourceStyles, children = [{}]}, screenName} = props;
    const [data, setData] = useState([])
    const {appEnv} = useSelector(state => state.app)
    const styles = sourceStyles ? sourceStyles[0] : {};
    const {
        source,
        slidesPerView,
        spaceBetween,
        autoplay
    } = properties;
    const swiperChildrenContainer = children[0] || {};
    const {globalValues} = useSelector(state => state.jsonScreen);
    let sourceData = getParamsFromString(source, globalValues, screenName) || [];
    const currentResolution = useCurrentResolution();
    let slidesPerViewAdaptive =
        currentResolution === 'mobile' ? 1 :
            currentResolution === 'tablet' ? 3 :
                currentResolution === 'laptop' ? 4 :
                slidesPerView;

    useEffect(() => {
        if (sourceData) {
            setData(sourceData)
        }
    }, [JSON.stringify(sourceData)])
    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<div ' + '' +
                'style="width: 50px; height: 4px !important; border-radius: 0; font-size: 0; background: #d3d3d3;" ' +
                'class="myPagination ' + className + '">' + (index + 1) + "</div>";
        }
    }
    return (
        <div style={{...styles}}>

            {properties.type === 'carousel' ? (
                <div style={{height: '100%',width: '100%'}}>
                <Swiper
                    pagination={pagination}
                    modules={[Pagination]}
                    style={{
                        height: '100%'
                    }}
                >
                        {children.map(swipeItem => {
                            const {styles: sourceStyles} = swipeItem;
                            const styles = sourceStyles ? sourceStyles[0] : {};
                            const backgroundImagePublicUrl = styles.backgroundImage ? process.env.NODE_ENV === 'development' ?
                                `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${styles.backgroundImage.url}` :
                                `/${appEnv}` + styles.backgroundImage.url : '';
                            return (
                                <SwiperSlide key={uid(swipeItem)}
                                             style={{
                                                 width: '100%',
                                                 height: '100%',
                                                 display: 'flex',
                                                 flexDirection: 'column',
                                                 justifyContent: styles.justifyContent,
                                                 alignItems: styles.alignItems,
                                                 background: styles.background,
                                                 backgroundImage: `url(${backgroundImagePublicUrl})`,
                                                 backgroundSize: 'cover'
                                             }}
                                >
                                    {(swipeItem.children || []).map(element => {
                                        return(
                                            <RenderComponents
                                                element={element}
                                            />
                                        )
                                    })}
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
            ) : (
                data.length ? (
                    <Swiper
                        style={{
                            height: '100%'
                        }}
                        slidesPerView={Number(slidesPerViewAdaptive)}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            600: {
                                slidesPerView: 1
                            },
                            800: {
                                slidesPerView: slidesPerView < 2 ? slidesPerView : 2,
                            },
                            1024: {
                                slidesPerView: slidesPerView < 3 ? slidesPerView : 3
                            },
                            1366: {
                                slidesPerView: slidesPerView < 4 ? slidesPerView : 4
                            }
                        }}
                        pagination={!autoplay}
                        centeredSlides={true}
                        spaceBetween={Number(spaceBetween) || 10}
                        loop={true}
                        navigation={false}
                        modules={autoplay ? modules.autoplay : modules.nonAutoplay}
                        className="mySwiper"
                    >
                        {data.map(swiperSlide => {
                            return (
                                <SwiperSlide key={uid(swiperSlide)}
                                             style={{
                                                 display: 'flex',
                                                 justifyContent: 'center'
                                             }}
                                >
                                    <SwiperChildrenContainer
                                        context={swiperSlide}
                                        component={swiperChildrenContainer}
                                    />
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                ) : (<>loading</>)
            )}


        </div>
    );
};

SwiperComponent.propTypes = {
    component: PropTypes.object
};

export default SwiperComponent;


const SwiperChildrenContainer = ({component, context}) => {
    const {styles: sourceStyles, children} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};

    return (
        <div style={{...styles}}>
            {children.map(item => {
                return (
                    <RenderComponents
                        key={uid(item)}
                        element={item}
                        actionsContext={context}
                    />
                )
            })}
        </div>
    )
}

export function useCurrentResolution() {
    const resolutions = [
        {
            id: 'mobile',
            result: useMediaQuery('(max-width:576px)')
        },
        {
            id: 'tablet',
            result: useMediaQuery('(max-width:768px)')
        },
        {
            id: 'laptop',
            result: useMediaQuery('(max-width:1366px)')
        },
        {
            id: 'desktop',
            result: useMediaQuery('(max-width:1400px)')
        },
    ]
    const currentRes = resolutions.filter(r => r.result === true)
    return currentRes.length ? currentRes[0].id : 'desktop';
}